<div class="eip-mxy-20">
  <fm-pivot #flexManhourGrid [licenseKey]="flexmonsterLicense"   *ngIf="newreport"
      [report]='newreport' id="idFMGridCommonDialog" [toolbar]="true">
  </fm-pivot>
</div>